import BookGallery from 'components/BookGallery';
import { Typography } from 'components/DesignSystemV2/Typography';
import LinkButton from 'components/LinkButton';
import { ResponsiveContainer } from 'components/ResponsiveContainer';
import React from 'react';
import { IconChervonRight } from 'shared/CourseLanding/icons/IconChervonRight';
import { colorsV2 } from 'style/colors-v2';
import styled from 'styled-components';
import { toScreen } from 'utils/media-query/responsive.util';

const Wrapper = styled.div`
  padding: 100px 0;
  background: linear-gradient(
    180deg,
    ${colorsV2.white100} 0%,
    ${colorsV2.blue10} 100%
  );

  ${toScreen(775)} {
    padding: 64px 0;
  }
`;

const Content = styled.div`
  display: flex;
  gap: 64px;

  ${toScreen(1143)} {
    flex-direction: column;
    max-width: 712px;
  }
`;

const Left = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`;

const Right = styled.div`
  flex: 1;
`;

const Badge = styled(Typography)`
  display: inline-block;
  background-color: ${colorsV2.blue10};
  padding: 4px 12px;
  border-radius: 8px;
`;

const ActionButton = styled(LinkButton)`
  color: ${colorsV2.blue100};

  &:hover {
    background-color: transparent;
    color: ${colorsV2.blue80};
  }
`;

const LinearThinkingBooks = ({ data }) => {
  const { title, badge, bookThumbnails, demoBookImages } = data;

  return (
    <Wrapper>
      <ResponsiveContainer>
        <Content>
          <Left>
            <Badge
              variant="semi-bold/16-24"
              color={colorsV2.blue100}
              type="span"
            >
              {badge}
            </Badge>
            <Typography
              desktopVariant="medium/32-40"
              tabletVariant="medium/28-36"
              variant="medium/24-32"
              color={colorsV2.black100}
              v3
            >
              {title}
            </Typography>
            <ActionButton
              href="/book"
              icon={<IconChervonRight width={18} height={18} />}
            >
              Xem thêm về sách
            </ActionButton>
          </Left>
          <Right>
            <BookGallery
              bookImages={bookThumbnails}
              demoBookImages={demoBookImages}
            />
          </Right>
        </Content>
      </ResponsiveContainer>
    </Wrapper>
  );
};

export default LinearThinkingBooks;
